import { onMounted, ref, computed } from "vue"
import { useStore } from "vuex"
import onTransitionendCallback from 'components/PageOverlay/methods/onTransitionendCallback'

export default {
    name: "LoginOverlay",
    props: {
        loginUrl: {
            type: String,
            required: true
        },
        createProfileUrl: {
            type: String,
            required: true
        }
    },
    setup(props){
        const store = useStore()
        const loginUrl = computed(() => props.loginUrl ?? store.state.main.page_overlay_content_data.loginUrl)
        const createProfileUrl = computed(() => props.createProfileUrl ?? store.state.main.page_overlay_content_data.createProfileUrl)
        const gtmActive = !!window?.dataLayer?.find(
            (element) => element['gtm.start']
        ) // check if gtm is active

        const descriptionWrapper = ref(null)

        let first,
            last,
            close

        const decodeHtml = (htmlRaw) => {
            const txt = document.createElement('textarea')
            txt.innerHTML = htmlRaw
            return txt.value
        }

        const tabTrap = function (e) {
            if (e.shiftKey && e.target.dataset.order === 'first') {
                e.preventDefault()
                close.focus()
            }

            if (!e.shiftKey && e.target.dataset.order === 'last') {
                e.preventDefault()
                close.focus()
            }

            if (!e.shiftKey && !e.target.dataset.order) {
                e.preventDefault()
                first.focus()
            }
        }

        onMounted(() => {

            var descriptionRaw = getLabel('text')
            var descriptionHtml = decodeHtml(descriptionRaw)
            descriptionWrapper.value.innerHTML = descriptionHtml
            
            first = document.querySelector(
                '.kb-button[data-order="first"]'
            )
            last = document.querySelector(
                '.kb-button[data-order="last"]'
            )
            close = document.querySelector('.kb-page-overlay__close')
            onTransitionendCallback(
                {
                    opening() {
                        first.focus()
                    }
                },
                { persistent: true }
            )

            if (!gtmActive) return
            const orderId = new URLSearchParams(document.location.search).get(
                'teamId'
            )
        })

        const getLabel = (labelKey) =>
            store.getters['labels/getLabel']({
                labelCollection: 'LoginOverlay',
                labelKey
            })

        return {
            loginUrl,
            createProfileUrl,
            descriptionWrapper,
            decodeHtml,
            tabTrap,
            getLabel
        }
    }
}